import * as React from 'react';
import {useEffect} from 'react';
import {postMessageToParent} from '../../utils/postMessage';
import {
  CREATE_TRANSACTION_MOBILE_URL_STATUS,
  MOBILE_URL_ERROR_MESSAGE, MOBILE_URL_ERROR_TYPE,
  POST_MESSAGE_TYPE
} from '../../common/constants';
import debug from 'debug';
import { createTransactionMobileUrl } from '../../libs/GsmpiApi';

const log = debug("app:MobileIframeTransactions");

export default function MobileIframeTransactions() {
  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data && event.data.type && event.data.type === 'create_transaction_mobile_url') {
          if (event.origin === event.data.sourceOrigin) {
            const createTransactionRequest = event.data.content;

            if (event.data.parentOrigin) {
              createTransactionRequest.sourceOrigin = event.data.parentOrigin;
            } else {
              createTransactionRequest.sourceOrigin = event.data.sourceOrigin;
            }

            const sourceOrigin = event.origin;

            createTransactionMobileUrl(createTransactionRequest)
              .then(mobileUrlResult => {
                log(`success to create transaction mobile url`);
                
                postMessageToParent({
                  type: POST_MESSAGE_TYPE.CREATE_TRANSACTION_MOBILE_URL_RESULT,
                  content: {
                    status: CREATE_TRANSACTION_MOBILE_URL_STATUS.SUCCESS,
                    data: mobileUrlResult
                  },
                  sourceOrigin: sourceOrigin
                });
              }).catch((error) => {
                log(`Failed to create transaction mobile url`);

                postMessageToParent({
                  type: POST_MESSAGE_TYPE.CREATE_TRANSACTION_MOBILE_URL_RESULT,
                  content: {
                    status: CREATE_TRANSACTION_MOBILE_URL_STATUS.FAIL,
                    errorCode: error.response?.data?.resultCode ?? MOBILE_URL_ERROR_TYPE.DEFAULT_ERROR,
                    message: error.response?.data?.resultMessage ?? MOBILE_URL_ERROR_MESSAGE.DEFAULT_ERROR
                  },
                  sourceOrigin: sourceOrigin
                });
              });
          }
        }
      },
      false
    );

    postMessageToParent({
      type: POST_MESSAGE_TYPE.READY_TO_CREATE_TRANSACTION,
      content: {},
      sourceOrigin: '*'
    });
  }, []);

  return (
    <>
      <div>
        Mobile IFrame Transactions Loading...
      </div>
    </>
  );
}